export default {
  colors: {
    white: '#fff',
    black: '#000',
    grey: '#e8e8e8',
    greyLight: '#7c7c7c',
    bg: '#0c193a',
    bgSticky: '#edeef0',
    overlay: 'rgba(1, 1, 1, 0.5)',
    primary: '#29b9ad',
    primaryDark: '#00dbcd',
    secondary: '#ffb950',
    secondaryGradient: '#e6685a',
    secondaryDark: '#ec5326',
  },

  screen: {
    xs: '360px',
    xsm: '500px',
    sm: '768px',
    md: '992px',
    lg: '1200px',
    xl: '1600px',
  },

  borders: {
    radius: '3px',
  },

  fonts: {
    defaultSize: '14px',
    defaultWeight: 400,
    bgSize: '26px',
    boldWeight: 600,
  },

  sizes: {
    maxWidth: '1600px',
    tabMinWidth: '140px',
    tabHeight: '50px',
  },
};
